import { Grid } from "@aws-amplify/ui-react";
import { useContext } from "react";

import ServiceOrdersAvailable from "components/maintenanceSchedules/ServiceOrdersAvailable";
import BigCalendar from "components/utils/BigCalendar/BigCalendar";
import ServiceOrderSelected from "components/maintenanceSchedules/ServiceOrderSelected";
import { ScheduleContext } from "components/maintenanceSchedules/context/ScheduleContext";

const ScheduleBoard = () => {
  const { selectedEvent } = useContext(ScheduleContext);

  return (
    <Grid
      templateColumns={{
        medium: "1fr",
        xl: `3fr ${selectedEvent ? "15fr 6fr" : "21fr"}`,
      }}
      rowGap="15px"
      columnGap="15px"
    >
      <ServiceOrdersAvailable />
      <BigCalendar />
      {selectedEvent && <ServiceOrderSelected />}
    </Grid>
  );
};

export default ScheduleBoard;
